import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Clock, AlertCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let attempt = 0;
    const poll = async () => {
      attempt += 1;
      setAttempts(attempt);
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (r.data.status === "expired") setStatus("expired");
        else if (attempt < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        if (attempt < 8) setTimeout(poll, 2000);
        else setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="checkout-success-page">
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-20 h-20 text-[#7AC143] mx-auto mb-6" />
          <h1 className="text-4xl font-black tracking-tighter text-[#1A2E1A]">Merci pour votre commande !</h1>
          <p className="text-[#4B634B] mt-4">Votre paiement a été reçu avec succès. Vous recevrez un email de confirmation.</p>
        </>
      )}
      {status === "pending" && (
        <>
          <Clock className="w-20 h-20 text-[#FACC15] mx-auto mb-6 animate-pulse" />
          <h1 className="text-4xl font-black tracking-tighter">Vérification du paiement...</h1>
          <p className="text-[#4B634B] mt-4">Tentative {attempts}/8</p>
        </>
      )}
      {(status === "expired" || status === "timeout" || status === "error") && (
        <>
          <AlertCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-4xl font-black tracking-tighter">Paiement non confirmé</h1>
          <p className="text-[#4B634B] mt-4">Votre paiement n'a pas pu être confirmé. Veuillez réessayer.</p>
        </>
      )}
      <Link to="/shop" className="inline-block mt-8 bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full px-7 py-3 font-semibold transition-colors" data-testid="continue-shopping-btn">
        Continuer mes achats
      </Link>
    </div>
  );
}
